const nominal = (
  name: string,
  phone: string,
  email: string,
  kidName: string,
  birthday: string,
  certNumber: string,
) => `
  <h2>Заявление об определении номинала сертификата дополнительного образования на соответствующий год</h2>
  <p>сведения о родителе (законном представителе) ребенка:</p>
  <ol>
    <li>фамилия, имя, отчество (при наличии): <span class="strong">${name}</span></li>
    <li>телефон: <span class="strong">${phone}</span></li>
    <li>электронная почта: <span class="strong">${email}</span></li>
  </ol>
  <p>сведения об обучающемся:</p>
  <ol>
    <li>фамилия, имя, отчество (при наличии): <span class="strong">${
      kidName ? kidName : ''
    }</span></li>
    <li>дата рождения: <span class="strong">${
      birthday ? birthday : ''
    }</span></li>
    <li>Номер сертификата дополнительного образования: <span class="strong">${
      certNumber ? certNumber : ''
    }</span></li>
  </ol>
  <p>Прошу определить на 2021 год номинал указанного выше сертификата дополнительного образования с учетом Программы персонифицированного финансирования на соответствующий год.</p>
  <p>Настоящим подтверждаю, что я ознакомлен(а) с Правилами персонифицированного финансирования дополнительного образования детей и обязуюсь соблюдать все без исключения положения указанных Правил, включая, но не ограничиваясь, правилами получения и использования сертификата дополнительного образования с определенным номиналом.</p>
`;

export default nominal;



// WEBPACK FOOTER //
// ./src/pages/profile/views/certificate/utils/nominal.ts